<div class="flex-row flex" style="overflow-x: auto">
    <div class="cb-padding-left-3x cb-padding-right-3x cb-padding-bottom-3x flex-col flex-100">
        <div class="start-center flex-row">
            <h3 class="mat-headline-6 flex">Pricing Complexities</h3>
            <button mat-raised-button (click)="newItemClicked()" color="primary">
                Add New Pricing Complexity
            </button>
        </div>
        <div class="cb-table cb-margin-top">
            <mat-table [dataSource]="searchResults">
                <ng-container matColumnDef="complexity">
                    <mat-header-cell *matHeaderCellDef> Complexity </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        {{ element.complexity }}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="targetWorkHours">
                    <mat-header-cell *matHeaderCellDef> Target Work Hours </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        {{ element.targetWorkHours }}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="targetCompletionHours">
                    <mat-header-cell *matHeaderCellDef> Target Completion Hours </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        {{ element.targetCompletionHours }}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="isActive">
                    <mat-header-cell *matHeaderCellDef> Active </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <mat-icon>
                            {{ element.isActive ? 'check_box' : 'check_box_outline_blank' }}
                        </mat-icon>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="actions" stickyEnd>
                    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <button mat-icon-button (click)="editItemClicked(element)">
                            <mat-icon> edit </mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
            </mat-table>
            @if (searchResultsLoaded && searchResults.length === 0) {
                <cb-info-message
                    [message]="'There are no Pricing Complexities to display'"
                    [icon]="'info_circle'"
                ></cb-info-message>
            }
            @if (!searchResultsLoaded) {
                <cb-loading-spinner></cb-loading-spinner>
            }
        </div>
    </div>
</div>
